import './dist/zinggrid.min.js';
export default ZingGrid;

